/**
 * Custom list of organization.
 */

Greenmile.OrganizationListBase = function (prefixId) {

    this.rootEl = document.createElement('div');
    this.data = [];

    const renderRow = (item) => {
        let rowList = document.createElement('li');

        if (item) {
            const rowId = prefixId + '_' + item.organization.id;
            const checkbox = new Monet.UI.Fields.Checkbox();
            const textToLabel = item.organization.key + ' - ' + item.organization.description;

            checkbox.setValue(item.hasVisibility);
            checkbox.render();

            rowList.setAttribute('organizationId', item.organization.id);

            checkbox.setInputId(rowId);
            checkbox.label.innerHTML = textToLabel;
            checkbox.label.title = textToLabel;
            checkbox.label.setAttribute('for', rowId);

            checkbox.input.addEventListener('change', () => {
                this.afterClickOnCheckBox(rowList, checkbox.input.checked);
            });

            rowList.appendChild(checkbox.rootEl);

            if (item.hasOwnProperty('childOrganizations')) {
                item.childOrganizations.forEach((item) => {
                    rowList.appendChild(renderRow(item));
                });
            }

        }
        return rowList;
    };

    const renderListOrganizations = (data) => {
        const fragment = document.createDocumentFragment();

        if (data && data.length) {
          data.forEach(function (item) {
              fragment.appendChild(renderRow(item));
          });
        }

        return fragment;
    };

    const renderFilter = () => {

        const filter = new Monet.UI.AjaxFilter();

        filter.callbackForSearch = (() => {
            this.renderOrganizationAfterFilter(filter.input.value);
        });

        return filter.render();
    };

    this.renderOrganizationAfterFilter = (valueToFilter) => {

        const list = this.rootEl.querySelector('ul');
        const data = this.filterOrganizations(valueToFilter);

        list.innerHTML = '';
        list.appendChild(renderListOrganizations(data));
    };

    this.filterOrganizations = (value) => {
        const newData = JSON.parse(JSON.stringify(this.data));
        const pattern = new RegExp(value, 'i');

        const filterOrganizations = (organizations) => {
            return organizations.filter(item => {
                const isMatchingParent = item.organization.key.match(pattern) || item.organization.description.match(pattern);

                if (isMatchingParent) {
                    if (item.childOrganizations && item.childOrganizations.length > 0) {
                        return true;
                    }
                    return true;
                }

                if (item.childOrganizations && item.childOrganizations.length > 0) {
                    const matchingChildren = item.childOrganizations.filter(child =>
                        child.organization.key.match(pattern) || child.organization.description.match(pattern)
                    );

                    if (matchingChildren.length) return true;
                }

                return false;
            });
        };

        const filteredOrganizations = filterOrganizations(newData);

        return filteredOrganizations;
    };

    this.setData = (data) => {

        this.data = data;
        return this;
    };

    this.render = () => {

        const listOrganization = document.createElement('ul');

        listOrganization.appendChild(renderListOrganizations(this.data));

        this.rootEl.className = 'containerOrganizationList';
        this.rootEl.appendChild(renderFilter());
        this.rootEl.appendChild(listOrganization);
        return this.rootEl;

    };
};
